import { AppState } from '../store';

export const posContextSelector = (state: AppState) => state.context.posContext;

export const isFetchingContextSelector = (state: AppState) =>
  state.context.isPending;

export const contextErrorSelector = (state: AppState) => state.context.error;
